import React from 'react'
import {Container,Row,Col, Form} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'

export default function Dashboard() { 
  const { t } = useTranslation()

  return (
    <>
          <Container className='cuerpo'>
              <Row className="text-left custom-card-header">
                  <h1>{t('signin.manage')}</h1>
                  <Form.Label className="form-label">{t('signin.selectaction')}</Form.Label>
                  <br/><br/><br/>
                  <Row className="text-center my-3">
                    <Col>
                      <Link to="/admin/users">
                          <i className="fas fa-user custom-fas-big"></i>
                          <br/>
                          {t('menu.user')}
                      </Link>
                    </Col>
                    <Col>
                      <Link to="/admin/machineries">
                        <i className="fas fa-tractor custom-fas-big"></i>
                        <br/>
                        {t('menu.machinery')}
                      </Link>
                    </Col>
                    <Col>
                      <Link to="/admin/counters">
                        <i className="fas fa-digital-tachograph custom-fas-big"></i>
                        <br/>
                        {t('menu.counters')}
                      </Link>
                    </Col>
                    <Col>
                      <Link to="/admin/products">
                        <i className="fas fa-spray-can custom-fas-big"></i>
                        <br/>
                        {t('menu.products')}
                      </Link>
                    </Col>
                  </Row>
                  <Row className="text-center my-3">
                    <Col>
                      <Link to="/admin/farms">
                        <i className="fas fa-map-marked custom-fas-big"></i>
                        <br/>
                        {t('menu.farms')}
                      </Link>
                    </Col>
                    <Col>
                      <Link to="/admin/plots">
                        <i className="fas fa-map-marked-alt custom-fas-big"></i>
                        <br/>
                        {t('menu.plots')}
                      </Link>
                    </Col>
                    <Col>
                      <Link to="/admin/crops">
                        <i className="fas fa-crop custom-fas-big"></i>
                        <br/>
                        {t('menu.crops')}
                      </Link>
                    </Col>
                    {/* <Col>
                      <Link to="/admin/campaigns">
                        <i className="fas fa-list-ol custom-fas-big"></i>
                        <br/>
                        {t('menu.campaigns')}
                      </Link>
                    </Col> */}
                    <Col>
                      <Link to="/admin/origens">
                        <i className="fas fa-map-marker-alt custom-fas-big"></i>
                        <br/>
                        {t('menu.origens')}
                      </Link>
                    </Col>
                  </Row>
                  <Row className="text-center my-3">
                    <Col>
                      <Link to="/admin/labors">
                        <i className="fas fa-clipboard-list custom-fas-big"></i>
                        <br/>
                        {t('menu.labors')}
                      </Link>
                    </Col>
                    <Col>
                      <Link to="/admin/logs">
                        <i className="fas fa-solid fa-clipboard-list custom-fas-big"></i>
                        <br/>
                        {t('menu.logs')}
                      </Link>
                    </Col>
                    <Col>
                    </Col>
                    <Col>
                    </Col>
                  </Row>
              </Row>
          </Container>
    </>
  )
}


  
                
